import React, { Component } from 'react';
import { NewsPage } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
class NewsPageView extends Component {

	render () {
		return <NewsPage content={this.props.content} />;
	}

}

export default withLanguageContext(NewsPageView);



// WEBPACK FOOTER //
// ./src/components/views/NewsPageView/NewsPageView.js